import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private _selectedThemeId: number | null = null;
  private _modeId: number = 1;

  get selectedThemeId() {
    return this._selectedThemeId;
  }

  set selectedThemeId(id: number | null) {
    this._selectedThemeId = id;
  }

  applyTheme(theme: any) {
    document.documentElement.style.setProperty('--theme-color', theme.code);
    document.documentElement.style.setProperty('--side-navbar-text', theme.text);
    document.documentElement.style.setProperty('--selected', theme.selected);
    document.documentElement.style.setProperty('--hover', theme.hover);

    this.selectedThemeId = theme.id;
    localStorage.setItem('theme', JSON.stringify(theme));
  }

  loadTheme() {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      const theme = JSON.parse(savedTheme);
      this.applyTheme(theme);
    }
  }

  clearTheme() {
    localStorage.removeItem('theme');
    document.documentElement.removeAttribute('style');
  }

  get modeId() {
    return this._modeId;
  }

  set modeId(id: number) {
    this._modeId = id;
  }

  applyMode(modeId: number) {
    this.modeId = modeId;
    const root = document.documentElement;
    root.classList.remove('dark-mode');

    if (modeId === 2) {
      root.classList.add('dark-mode');
    } else if (modeId === 3) {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      if (prefersDark) root.classList.add('dark-mode');
    }

    localStorage.setItem('mode', JSON.stringify({ id: modeId }));
  }

  loadMode() {
    const savedMode = localStorage.getItem('mode');
    if (savedMode) {
      const mode = JSON.parse(savedMode);
      this.applyMode(mode.id);
    } else {
      this.applyMode(1);
    }
  }

  clearMode() {
    localStorage.removeItem('mode');
    document.documentElement.classList.remove('dark-mode');
  }
}
